import { Button, ButtonTheme } from '@apply/components';

export interface WizardAsideProps {
    id: string;
    onSaveAndExit: () => void;
    saveAndExitText?: string;
    disabled?: boolean;
}

/** Right column for WizardModal: the "Save and Exit" action. */
export const WizardAside = ({ id, onSaveAndExit, saveAndExitText = 'Save and Exit', disabled = false }: WizardAsideProps) => {
    return (
        <Button
            id={`${id}_saveAndExit`}
            theme={ButtonTheme.LinkBlue}
            handleClick={onSaveAndExit}
            disabled={disabled}
        >
            {saveAndExitText}
        </Button>
    );
};
